<template>
  <div id="time_popup__wrap" class="dimmed">
    <div class="time_popup__content">
      <i class="icon icon--time"></i>
      <div class="time-text--wrap">
        <p class="time-title">
          {{
            AB_ALREADY_STARTED
              ? $t('common.validationErrorText.ab.addPage.alreadyStarted')
              : $t('common.reSelect')
            }}
        </p>
        <p class="time-desc" v-html="AB_ALREADY_STARTED ? $t('common.validationErrorText.ab.addPage.alreadyStartedDesc') : $t('common.timeReset')">
        </p>
      </div>
      <button class="popup-confirm" @click="closePopup">{{ $t('common.confirm') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisTimeSetting',
  props: {
    AB_ALREADY_STARTED: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('closeTimePopup', false)
    }
  }
}
</script>

<style lang="scss" scoped>
#time_popup__wrap {

  .time_popup__content {
    @include positionXYcenter;
    border-radius: 14px;
    background: #FFF;
    box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
    width: 430px;
    height: 323px;
    padding: 50px 50px 25px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    > .icon.icon--time {
      background-image: url("../../assets/img/icon-time-alert.svg");
      width: 50px;
      height: 50px;
      background-position: center;
    }

    .time-text--wrap {
      text-align: center;
      .time-title {
        color: #444;
        font-size: 20px;
        font-weight: 500;
        line-height: 26px;
      }

      .time-desc {
        margin-top: 12px;
        color: #000;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .popup-confirm {
      margin-top: 50px;
      display: flex;
      height: 38px;
      min-width: 90px;
      padding: 9px 18px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 61px;
      border: 1px solid #BBB;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.06);
      }
    }
  }
}
</style>
